import { SET_APP_CONFIGURATIONS, SET_AWS_CREDENTIALS } from '../../../actions'

export const appConfigurations = (state = {}, action) => {
  switch (action.type) {
    case SET_APP_CONFIGURATIONS:
      return { ...state, ...action.payload }

    default:
      return state
  }
}

export const appCredentials = (state = {}, action) => {
  switch (action.type) {
    case SET_AWS_CREDENTIALS:
      return { ...state, ...action.payload }

    default:
      return state
  }
}
